export default function VerificationPending({
  className,
  classNameIcon
}: {
  className: string
  classNameIcon: string
}) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="4" width="5" height="6" fill="currentColor" />
      <rect x="12" y="4" width="6" height="1" fill="currentColor" />
      <rect x="12" y="6" width="6" height="1" fill="currentColor" />
      <rect x="12" y="8" width="6" height="1" fill="currentColor" />
      <rect x="6" y="12" width="12" height="1" fill="currentColor" />
      <rect x="6" y="14" width="7" height="1" fill="currentColor" />
      <rect x="6" y="16" width="4" height="1" fill="currentColor" />
      <rect x="6" y="18" width="6" height="1" fill="currentColor" />
      <path
        className={classNameIcon}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 19C23 21.7614 20.7614 24 18 24C15.2386 24 13 21.7614 13 19C13 16.2386 15.2386 14 18 14C20.7614 14 23 16.2386 23 19ZM20.8432 16.8965C21.0845 17.0861 21.1264 17.4353 20.9368 17.6766L18.0601 21.3378C17.7443 21.7399 17.1331 21.733 16.8263 21.324L15.3333 19.3333C15.1492 19.0879 15.199 18.7396 15.4444 18.5556C15.6899 18.3715 16.0381 18.4212 16.2222 18.6667L17.4547 20.31L20.0632 16.9901C20.2527 16.7488 20.602 16.7069 20.8432 16.8965Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3H19V13.083C19.3442 13.1407 19.6784 13.2277 20 13.3414V3V2H19H5H4V3V21V22H5H12.8027C12.6198 21.6838 12.4649 21.3493 12.3414 21H5V3Z"
        fill="currentColor"
      />
    </svg>
  )
}
